import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getDomainFromToken, isAuthenticated } from "../commons/Auth/auth";

const SuperAdminRoutes = ({ component: Component, ...rest }) => {
  const domain = getDomainFromToken();
  const getLoginRedirect = () => {
    if (domain) {
      try {
        const url = new URL(domain);
        return `${url.origin}/login`;
      } catch {
        return "/login";
      }
    }
    return "/login";
  };

  return (
    <Route
      {...rest}
      render={props =>
        isAuthenticated() && isAuthenticated().role === 4 ? (
          <Component {...props} />
        ) : (
          <Redirect to={getLoginRedirect()} />
        )
      }
    />
  );
};

export default SuperAdminRoutes;
